import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { bool } from "prop-types";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox
} from "react-bootstrap";
import fileDownload from "js-file-download";

import SMSTextField from "../SMSTextField";

import config from "../../config";
import { getAuthToken } from "../../utils/sessionStorage";

class ExportSendingModal extends Component {
  constructor() {
    super();

    this.state = {
      value: "",
      isSMSValid: false,
      hasSMS: false,
      smsText: "",
      disabled: false
    };

    this.getValidationState = this.getValidationState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.export = this.export.bind(this);
    this.handleSMSTextUpdate = this.handleSMSTextUpdate.bind(this);
  }
  handleSMSTextUpdate(SMSTextObject) {
    this.setState({
      disabled: !SMSTextObject.isValid,
      isSMSValid: SMSTextObject.isValid,
      smsText: SMSTextObject.text
    });
  }
  getValidationState() {
    // const value = this.state.value;
    // const length = value.length;
    // if (length > 118) return "error";
    // else if (length === 0) return null;
    // else if (!/\*\|URL\|\*/g.test(value)) return "error";
    // else if (/\*\|URL\|\*/.test(value)) return "success";
    return null;
  }
  handleChange(e) {
    let value = e.target.value;
    this.setState({ value });
  }
  export() {
    if (this.state.hasSMS && !this.state.isSMSValid) {
      console.log("SMS INVALIDO");
      return;
    }
    const { video, sendingId } = this.props;
    let url = `/campaigns/${video.campaign_id}/videos/${
      video.id
    }/sendings/${sendingId}/export`;

    let data = {
      custom_fields_keys: this.state.value
    };

    if (this.state.hasSMS && this.state.isSMSValid) {
      data["sms_text"] = this.state.smsText;
    }
    axios({
      method: "post",
      // responseType: "blob",
      url: `${config.url}${url}`,
      headers: { "X-User-Token": getAuthToken() },
      data: data
    }).then(res => {
      if (res.data.size === 0) {
        toastr.error("A busca não gerou nenhum resultado.");
        return;
      }
      toastr.success("CSV gerado com sucesso!");
      fileDownload(res.data, `exportacao_base__${video.title}.csv`);
    });
  }
  render() {
    const { show } = this.props;
    return (
      <Modal show={show}>
        <Modal.Header>Exportação de Campaign Sending</Modal.Header>
        <Modal.Body>
          <FormGroup
            controlId="formBasicText"
            validationState={this.getValidationState()}
          >
            <ControlLabel>
              Digite os campos extras a serem importados.
            </ControlLabel>
            <FormControl
              type="text"
              value={this.state.value}
              placeholder="CLIENTE,CODIGO,PRODUTO"
              onChange={this.handleChange}
            />
          </FormGroup>

          <Checkbox
            onChange={e => {
              this.setState({
                hasSMS: e.target.checked,
                disabled: e.target.checked
              });
            }}
          >
            Adicionar texto SMS
          </Checkbox>
          {this.state.hasSMS ? (
            <SMSTextField onUpdate={this.handleSMSTextUpdate} />
          ) : null}
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-link" onClick={this.props.close}>
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              this.export();
            }}
            disabled={this.state.disabled}
          >
            Exportar
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ExportSendingModal.propTypes = {
  show: bool
};

export default ExportSendingModal;



// WEBPACK FOOTER //
// ./src/components/modals/ExportSendingModal.js